export interface WeldSetupAdminTab {
  label: string;
  value: WeldSetupAdminTabType;
}

export enum WeldSetupAdminTabType {
  PIPING = 'Piping',
  STRUCTURAL = 'Structural',
}
